/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightSupportCapability
 */
export interface FlightSupportCapability {
    /**
     *
     * @type {string}
     * @memberof FlightSupportCapability
     */
    name: FlightSupportCapabilityNameEnum;
    /**
     * True when available from bounded evidence, false when unavailable, and null when a fresh provider read is required.
     * @type {boolean}
     * @memberof FlightSupportCapability
     */
    available: boolean | null;
    /**
     *
     * @type {string}
     * @memberof FlightSupportCapability
     */
    source: FlightSupportCapabilitySourceEnum;
    /**
     *
     * @type {string}
     * @memberof FlightSupportCapability
     */
    reason: FlightSupportCapabilityReasonEnum;
}


/**
 * @export
 */
export const FlightSupportCapabilityNameEnum = {
    Book: 'book',
    InstantTicketing: 'instant_ticketing',
    DeferredTicketing: 'deferred_ticketing',
    Cancel: 'cancel',
    Void: 'void',
    Refund: 'refund'
} as const;
export type FlightSupportCapabilityNameEnum = typeof FlightSupportCapabilityNameEnum[keyof typeof FlightSupportCapabilityNameEnum];

/**
 * @export
 */
export const FlightSupportCapabilitySourceEnum = {
    CodePosture: 'code_posture',
    PersistedEvidence: 'persisted_evidence',
    FreshProviderReadRequired: 'fresh_provider_read_required',
    Unknown: 'unknown'
} as const;
export type FlightSupportCapabilitySourceEnum = typeof FlightSupportCapabilitySourceEnum[keyof typeof FlightSupportCapabilitySourceEnum];

/**
 * @export
 */
export const FlightSupportCapabilityReasonEnum = {
    DisabledByPolicy: 'disabled_by_policy',
    UnavailableWithoutProviderRead: 'unavailable_without_provider_read',
    PersistedCompleted: 'persisted_completed',
    CompatibilityUnknown: 'compatibility_unknown'
} as const;
export type FlightSupportCapabilityReasonEnum = typeof FlightSupportCapabilityReasonEnum[keyof typeof FlightSupportCapabilityReasonEnum];


/**
 * Check if a given object implements the FlightSupportCapability interface.
 */
export function instanceOfFlightSupportCapability(value: object): value is FlightSupportCapability {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('available' in value) || value['available'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function FlightSupportCapabilityFromJSON(json: any): FlightSupportCapability {
    return FlightSupportCapabilityFromJSONTyped(json, false);
}

export function FlightSupportCapabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightSupportCapability {
    if (json == null) {
        return json;
    }
    return {

        'name': json['name'],
        'available': json['available'],
        'source': json['source'],
        'reason': json['reason'],
    };
}

export function FlightSupportCapabilityToJSON(json: any): FlightSupportCapability {
    return FlightSupportCapabilityToJSONTyped(json, false);
}

export function FlightSupportCapabilityToJSONTyped(value?: FlightSupportCapability | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'name': value['name'],
        'available': value['available'],
        'source': value['source'],
        'reason': value['reason'],
    };
}

